<script>
import { authComputed } from "/src/store/helpers";
export default {
    computed: {
        ...authComputed,
    },

    methods: {
        logout() {
            this.$store.dispatch("logout");
        },
    },

    name: "NavigationBar",
};
</script>

<template>
    <div class="nav">
        <router-link to="/">
            <img class="nav-logo" src="../../styles/images/UT-techmed-logo.png" />
        </router-link>

        <router-link v-if="loggedIn" to="/" class=" button no-underline "> Home </router-link>
        <router-link v-if="loggedIn" to="/admin" class="button no-underline">
            Admin
        </router-link>
        <router-link v-if="loggedIn" to="/" class="button no-underline" @click="logout">
            Logout
        </router-link>

        <img class="nav-logo" src="../../styles/images/MDI-logo.png" />
    </div>
</template>

<style scoped lang="less"></style>
